<app-navbar></app-navbar>

<div class="bg-white">
    <div class="bg-gradient-hero sliders">
        <div *ngIf="integration" class="mt-28 pb-10 pt-12 px-4 md:px-20 lg:px-28 flex gap-6 flex-col-reverse lg:flex-row">
            <div class="lg:hidden" [innerHTML]="overview"></div>
            <div class="mb-4 lg:mb-0 max-w-xs mx-auto w-full lg:w-1/4 h-fit p-6 rounded-xl bg-white border border-gray-300 flex flex-col items-center">
                <div class="pb-8">
                    <img [src]="imgPath + integration.hI_IMAGE" [alt]="integration.hI_NAME" class="w-max-full max-h-14">
                </div>

                <div class="text-left gray-text" [innerHTML]="integration.hI_DESCRIPTION"></div>

                <div class="rounded-full bg-primary text-white px-4 py-2 mt-4 cursor-pointer hover:bg-yellow-700 transition-all ease-in-out text-center" (click)="scrollToElement('demo')">
                    {{ 'integrationsHeader.askDemo' | translate }}
                </div>
            </div>
            <div class="w-full lg:w-3/4">
                <div class="green-header mb-3 text-center lg:text-left">{{ integration.hI_NAME }}</div>
                <div class="gray-header mb-4 text-center lg:text-left">{{ integration.hI_TITLE }}</div>
                <div class="hidden lg:block" [innerHTML]="overview"></div>
            </div>
        </div>

        <hr>

        <div id="demo" *ngIf="integration" class="mt-10 pb-10 px-4 md:px-20 lg:px-28">
            <div class="green-header2 mb-6 text-center">{{ 'integrationsHeader.discoverHaibu' | translate:{integration: integration.hI_NAME} }}</div>
            <div class="py-10 px-5 sm:px-8 md:px-12 rounded-xl bg-white border border-gray-300 max-w-form mx-auto">
                <div class="text-form text-form-gray text-sm mb-5" [innerHTML]="'loginFillAllForm2' | translate">
                </div>
                <form [formGroup]="demoForm" class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full form-login">
                  <div class="pb-3">
                    <span class="block text-sm font-medium text-gray-600 mb-1 inter">
                      {{ 'loginAskDemoName' | translate }}
                    </span>
                    <mat-form-field appearance="outline" class="w-full border-radius" floatLabel="always">
                      <input #nameInput id="loginNameInput" maxlength="40" formControlName="names" matInput type="text"
                        class="validate w-full border-radius rounded-lg" [placeholder]="'loginAskDemoNamePlace' | translate"
                        required oninput="this.value = this.value.replace(/[^a-zA-Z0-9À-ÿ\u00f1\u00d1\s.´]/g, '').trimStart();">
                    </mat-form-field>
                    <div *ngIf="demoForm.get('names').invalid && (demoForm.get('names').dirty || demoForm.get('names').touched)"
                      class="text-red-500 text-xs mt-3 -mb-6">
                      <span *ngIf="demoForm.get('names').errors['required']">
                        {{ 'hasWhiteSpaceKeyForm' | translate: { key: 'loginAskDemoName' | translate } }}
                      </span>
                      <span *ngIf="demoForm.get('names').errors['noSpecialCharacters']">
                        {{ 'invalidCharactersKeyForm' | translate: { key: 'loginAskDemoName' | translate } }}
                      </span>
                    </div>
                  </div>
        
                  <div class="pb-3">
                    <span class="block text-sm font-medium text-gray-600 mb-1 inter">
                      {{ 'loginAskDemoLastName' | translate }}
                    </span>
                    <mat-form-field appearance="outline" class="w-full">
                      <input id="loginLastNameInput" maxlength="40" formControlName="lastnames" matInput type="text"
                        class="validate w-full" [placeholder]="'loginAskDemoLastNamePlace' | translate" required
                        oninput="this.value = this.value.replace(/[^a-zA-Z0-9À-ÿ\u00f1\u00d1\s.´]/g, '').trimStart();">
                    </mat-form-field>
                    <div
                      *ngIf="demoForm.get('lastnames').invalid && (demoForm.get('lastnames').dirty || demoForm.get('lastnames').touched)"
                      class="text-red-500 text-xs mt-3 -mb-6">
                      <span *ngIf="demoForm.get('lastnames').errors['required']">
                        {{ 'hasWhiteSpaceKeyForm' | translate: { key: 'loginAskDemoLastName' | translate } }}
                      </span>
                      <span *ngIf="demoForm.get('lastnames').errors['noSpecialCharacters']">
                        {{ 'invalidCharactersKeyForm' | translate: { key: 'loginAskDemoLastName' | translate } }}
                      </span>
                    </div>
                  </div>
        
                  <div class="pb-3">
                    <span class="block text-sm font-medium text-gray-600 mb-1 inter">
                      {{ 'loginAskDemoEmail' | translate }}
                    </span>
                    <mat-form-field appearance="outline" class="w-full">
                      <input id="loginEmailInput" maxlength="80" formControlName="email" matInput type="text" class="validate"
                        [placeholder]="'loginAskDemoEmailPlace' | translate" required oninput="this.value = this.value.trim();">
                    </mat-form-field>
                    <div *ngIf="demoForm.get('email').invalid && (demoForm.get('email').dirty || demoForm.get('email').touched)"
                      class="text-red-500 text-xs mt-3 -mb-6">
                      <span *ngIf="demoForm.get('email').errors['required']">{{ 'hasWhiteSpaceKeyForm' | translate: { key:
                        'loginAskDemoEmail' | translate } }}</span>
                      <span
                        *ngIf="!demoForm.get('email').errors['required'] && (demoForm.get('email').errors['email'] || demoForm.get('email').errors['isEmailValid'])">{{
                        'emailMassiveLinkValid' | translate }}</span>
                    </div>
                  </div>
        
                  <div class="pb-3">
                    <span class="block text-sm font-medium text-gray-600 mb-1 inter">
                      {{ 'loginAskDemoPhone' | translate }}
                    </span>
                    <mat-form-field appearance="outline" class="w-full">
                      <input id="loginCellPhoneInput" maxlength="10" minlength="10"
                        (keypress)="($event.charCode >= 48 && $event.charCode < 58)" formControlName="phone" matInput
                        type="text" class="validate" [placeholder]="'loginAskDemoPhonePlace' | translate" required
                        oninput="this.value = this.value.replace(/[^0-9]/g, '').trim();">
                    </mat-form-field>
                    <div *ngIf="demoForm.get('phone').invalid && (demoForm.get('phone').dirty || demoForm.get('phone').touched)"
                      class="text-red-500 text-xs mt-3 -mb-6">
                      <span *ngIf="demoForm.get('phone').errors['required']">
                        {{ 'hasWhiteSpaceKeyForm' | translate: { key: 'loginAskDemoPhone' | translate } }}
                      </span>
                      <span *ngIf="!demoForm.get('phone').errors['minlength'] && demoForm.get('phone').errors['isPhoneValid']">
                        {{ 'phoneNumberInvalid' | translate }}
                      </span>
                      <span *ngIf="demoForm.get('phone').errors['minlength']">
                        {{ 'invalidAtLeastLengthKeyForm' | translate: { key: 'loginAskDemoPhone' | translate, number: 10 }
                        }}
                      </span>
                    </div>
                  </div>
        
                  <div class="pb-3">
                    <span class="block text-sm font-medium text-gray-600 mb-1 inter">
                      {{ 'loginAskDemoCompany' | translate }}
                    </span>
                    <mat-form-field appearance="outline" class="w-full">
                      <input id="loginBussinesInput" maxlength="100" formControlName="company" matInput type="text"
                        class="validate" [placeholder]="'loginAskDemoCompanyPlace' | translate" required
                        oninput="this.value = this.value.replace(/[^a-zA-Z0-9À-ÿ\u00f1\u00d1\s.´]/g, '').trimStart();">
                    </mat-form-field>
                    <div
                      *ngIf="demoForm.get('company').invalid && (demoForm.get('company').dirty || demoForm.get('company').touched)"
                      class="text-red-500 text-xs mt-3 -mb-6">
                      <span *ngIf="demoForm.get('company').errors['required']">
                        {{ 'hasWhiteSpaceKeyForm' | translate: { key: 'loginAskDemoCompany' | translate } }}
                      </span>
                      <span *ngIf="demoForm.get('company').errors['noSpecialCharacters']">
                        {{ 'invalidCharactersKeyForm' | translate: { key: 'loginAskDemoCompany' | translate } }}
                      </span>
                    </div>
                  </div>
        
                  <div class="pb-3">
                    <span class="block text-sm font-medium text-gray-600 mb-1 inter">
                      {{ 'loginAskCountNumber' | translate }}
                    </span>
                    <mat-form-field appearance="outline" class="w-full logindepaddme">
                      <mat-select id="loginNumberEmployeesSelect" formControlName="userLimit"
                        [placeholder]="'loginAskCountNumberPlace' | translate" required>
                        <mat-option *ngFor="let userLimit of userLimits; let i = index" [value]="userLimit.usrlD_DESCRIPTION">
                          {{ userLimit.usrlD_DESCRIPTION }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div
                      *ngIf="demoForm.get('userLimit').invalid && (demoForm.get('userLimit').dirty || demoForm.get('userLimit').touched)"
                      class="text-red-500 text-xs mt-4 -mb-6">
                      <span *ngIf="demoForm.get('userLimit').errors['required']">
                        {{ 'hasWhiteSpaceKeyForm' | translate: { key: 'loginAskCountNumber' | translate } }}
                      </span>
                    </div>
                  </div>
        
                  <div class="pb-3 col-span-1 md:col-span-2">
                    <span class="block text-sm font-medium text-gray-600 mb-1 inter">
                      {{ 'loginAskCountry' | translate }}
                    </span>
                    <mat-form-field appearance="outline" class="w-full logindepaddme">
                      <mat-select id="loginCountrySelect" formControlName="country"
                        [placeholder]="'loginAskCountryPlace' | translate" required>
                        <mat-option *ngFor="let country of countries; let i = index" [value]="country.ctrD_NAME">
                          {{ country.ctrD_NAME }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div
                      *ngIf="demoForm.get('country').invalid && (demoForm.get('country').dirty || demoForm.get('country').touched)"
                      class="text-red-500 text-xs mt-4 -mb-4">
                      <span *ngIf="demoForm.get('country').errors['required']">
                        {{ 'hasWhiteSpaceKeyForm' | translate: { key: 'loginAskCountry' | translate } }}
                      </span>
                    </div>
                  </div>
        
                  <div class="pt-3 col-span-1 md:col-span-2">
                    <re-captcha #captchaComponent (resolved)="resolved($event)" name="captcha"
                      siteKey="6LdhgoYpAAAAAKlDW2aRdu6nH_Gmk0KTTU7tcoMr"></re-captcha>
                  </div>
        
                  <div class="py-2 col-span-1 md:col-span-2">
                    <input id="termsAndConditionsAccepted" formControlName="terms" type="checkbox" id="terms" name="terms"
                      required>
                    <label for="terms">
                      {{ "loginAskAcept" | translate }}
                      <a class="cursor-pointer color-haibu" href="/terms" target="_blank">{{ "loginTermsAndCondition" |
                        translate }}</a>
                    </label>
                    <br>
                    <mat-error class="error-label" *ngIf="demoForm.controls.terms.invalid && demoForm.controls.terms.touched">
                      {{ 'mustAcceptTerms' | translate }}
                    </mat-error>
                  </div>
                </form>
        
                <div id="loginWantACall"
                  class="px-5 py-2.5 text-center text-white text-lg bg-primary rounded-lg mt-4 w-fit btn-primary cursor-pointer mx-auto"
                  (click)="sendMail()">
                  {{ 'loginSentEmail' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer *ngIf="integration"></app-footer>